// Kart tipi -> bilesen. Yeni tip: buraya bir satir + sema alani.
import AskCard from "./AskCard.vue";
import ArticlesCard from "./ArticlesCard.vue";
import LinkCard from "./LinkCard.vue";
import AnnouncementCard from "./AnnouncementCard.vue";
import CtaCard from "./CtaCard.vue";
export const CARD_COMPONENTS = { ask: AskCard, articles: ArticlesCard, link: LinkCard, announcement: AnnouncementCard, cta: CtaCard };



// WEBPACK FOOTER //
// ./src/components/V2/shell/cards/index.js